import $ from 'jquery';

let inactivityTimer;
const INACTIVITY_TIMEOUT = 30000; // 30 seconds

const startInactivityTimer = () => {
	let shouldOpen = $( '.silent-login' );

	if ( shouldOpen.length === 0 ) {
		return;
	}

	inactivityTimer = setTimeout(handleInactivity, INACTIVITY_TIMEOUT);
}

const resetInactivityTimer = () => {
	clearTimeout(inactivityTimer);
	startInactivityTimer();
}

const handleInactivity = () => {
	let $silentLoginModal = $( '#reveal-silent-login' );

	$.ajax( {
		type: "POST",
		url: psh_vars.rest_route.psh_customer_silent_login,
		success: function (result) {
			if ( result.success && result.is_logged_in ) {
				resetInactivityTimer();
			}
		},
		error: function ( error ) {
			if ( error.status === 403 ) {
				$silentLoginModal.foundation('open');

				let login_wrapper = $( '.header-right__icon--login' );
				let login_user_text = login_wrapper.find( '.header-right__icon--text' )
				let login_dropdown_icon = login_wrapper.find( '.header-right__icon--text + svg' )
				let login_dropdown = login_wrapper.find( '.dropdown' )

				login_user_text.remove()
				login_dropdown.remove()
				login_dropdown_icon.remove()

				login_wrapper.append( '<a href="'+ psh_vars.my_account +'" class="header-right__icon--text">' + psh_vars.login_text + '</a>' )
			}
		}
	} );
}

startInactivityTimer();